import React from 'react';
import './Header.scss'
import 'bootstrap/dist/css/bootstrap.min.css';
import banner from './../../media/itunes.png';


class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list:[],
            isLoaded : false
        }
    }

    fetchSongs = (e) => {
        e.preventDefault();
        console.log(this.refs.name.value)
        fetch(`https://cors-anywhere.herokuapp.com/https://itunes.apple.com/search?term=${this.refs.name.value}&limit=${this.refs.number.value}`)
        .then(res => res.json())
        .then((data) => {
          console.log(data); 
          this.setState ({
            list: data.results,
            isLoaded: true,
          })
        });
        console.log("Error")
      }

    render() {
        return (
            <div className="song-search-wrapper">
                <form className="form-wrapper" onSubmit = {this.fetchSongs}>
                    <div className="banner-wrapper">
                        <img src={banner} alt="image-banner"></img>
                        <div className="itunes-heading">Song Search</div>
                        <div className="itune-description">Preview and surf the songs from iTunes Library.</div>
                    </div>
                    <div className="input-wrapper">
                        <input className="enter-artist" type = 'text' placeholder = 'Enter Artist' ref="name"></input>
                        <input className="enter-number" type = 'number' placeholder = 'Number' ref="number"></input>
                        <input className="submit" type = 'submit' placeholder='Submit' value = 'Submit'></input>
                    </div>

                </form>
                <div className="card-wrapper">
                
                {this.state.isLoaded ? (
                    this.state.list.map((item, index) => (
                        <div className="item-wrapper" key={index} >
                            <div className="inner-wrapper box">
                                <div className="image-wrapper">
                                    <img src={item.artworkUrl100}></img>
                                </div>
                                <div className="song-name">{item.trackName}</div>
                                <div className="artist-name">{item.artistName}</div>
                                <button onClick={()=> window.open(item.previewUrl, "_blank")} onKeyPress={()=>{}}className="preview-button">Preview Song</button>
                            </div>
                        </div>
                    ))
                    ) : ""
                }
                </div>

            </div>
        );
    }
}

export default Header;